import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import InputMask from 'react-input-mask';

export class AddContact extends Component {

    constructor(props) {
        super(props);

        this.state = {
            contactfirstname: '',
            contactlastname: '',
            contactcellphone: '',
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }


    toggleModal() {
        this.setState({
            contactfirstname: '',
            contactlastname: '',
            contactcellphone: '',
        });


        this.props.toggle();
    }


    handleSubmit(e) {
        e.preventDefault();
        this.props.toggle();
        const { contactfirstname, contactlastname, contactcellphone } = this.state;
        this.setState({
            contactfirstname: '',
            contactlastname: '',
            contactcellphone: '',
        });

        this.props.addContact(contactfirstname, contactlastname, contactcellphone);
    }

    componentWillReceiveProps(nextProps) {
        // this will run every time the props change 
        if (this.props.contactcellphone !== nextProps.contactcellphone) {
            this.setState({
                contactcellphone: this.props.contactcellphone
            });
        }
    }

    render() {

        const { contactfirstname, contactlastname, contactcellphone } = this.state;
        var contactcellphonedigits = ('' + contactcellphone).replace(/\D/g, '')

        return (

            <Modal isOpen={this.props.isOpen} toggle={this.toggleModal} className={this.props.className}>
                <ModalHeader toggle={this.toggleModal}>Add Contact</ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label className="form-label semibold" >First Name</label>
                        <input type="text" className="form-control" name="contactfirstname" placeholder="First Name" value={contactfirstname} onChange={this.handleChange} />
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >Last Name</label>
                        <input type="text" className="form-control" name="contactlastname" placeholder="Last Name" value={contactlastname} onChange={this.handleChange} />
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >Cell Phone</label>
                        <InputMask className="form-control" name="contactcellphone" mask="(999) 999-9999" value={contactcellphone} maskChar=" " onChange={this.handleChange} />
                    </div>


                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" className="btn btn-rounded" onClick={this.toggleModal}>Close</Button>
                    <Button color="primary" className="btn btn-rounded" disabled={contactcellphonedigits.match(/^(\d{3})(\d{3})(\d{4})$/)? false : true} onClick={this.handleSubmit}>Add</Button>{' '}
                </ModalFooter>
            </Modal>

        );
    }

}